import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "step-nav step-nav--ticket" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "step-nav__counter" }
const _hoisted_4 = {
  key: 0,
  class: "icon icon-checkmark",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "step-nav__text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "step-nav__indicator" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-nav__indicator__foreground" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepViews, (view, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["step-nav__item", {
                 'active': index === _ctx.step,
                 'is-previous' : index < _ctx.step,
                 'is-most-current-previous no-animation-delay': index === _ctx.step - 1,
             }]),
        onClick: ($event: any) => (_ctx.step > index ? _ctx.changeStep(index, view) : '')
      }, [
        _createElementVNode("div", _hoisted_3, [
          (index === _ctx.stepViews.length -1 || index < _ctx.step)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.translate('shop.configuration.' + view + '-view')), 1)
        ]),
        _hoisted_6
      ], 10, _hoisted_2))
    }), 256))
  ]))
}